/**
 * Composable: usePlainTm
 * Resolves i18n message ASTs (from tm()) into plain strings/objects.
 * Must be called after useI18n() is available.
 */
export function usePlainTm() {
  const { tm, rt } = useI18n();

  function resolveMessage(val) {
    if (typeof val === "string") return val;
    if (Array.isArray(val)) return val.map(resolveMessage);
    if (val && typeof val === "object") {
      try {
        const resolved = rt(val);
        if (typeof resolved === "string") return resolved;
      } catch (e) {
        // not a message AST, recurse into plain object
      }
      const result = {};
      for (const key of Object.keys(val)) {
        result[key] = resolveMessage(val[key]);
      }
      return result;
    }
    return val;
  }

  function plainTm(key) {
    const val = tm(key);
    return val == null ? val : resolveMessage(val);
  }

  return { plainTm, resolveMessage };
}
